import classNames from 'classnames';

import renderIcon from '../../utils/renderIcon';

const ns = `scroll-hint`;

/*
* Fading "scroll for more" affordance for scrollable panels.
* Pairs with the useScrollHint hook (src/utils/hooks.js):
*
*   const {
*     panelRef, showScrollHint, updateScrollHint, handleScrollHintClick,
*   } = useScrollHint(isOpen);
*   <div ref={panelRef} onScroll={updateScrollHint}>...</div>
*   <ScrollHint visible={showScrollHint} onClick={handleScrollHintClick} />
*/
const ScrollHint = ({ visible = false, onClick, label = 'Scroll for more' }) => {
	const rootClassnames = classNames({
		[`${ ns }`]: true,
		'is-visible': visible,
	});

	return (
		<button
			type={`button`}
			className={rootClassnames}
			onClick={onClick}
			aria-hidden={!visible}
			tabIndex={visible ? 0 : -1}
		>
			<span className={`${ ns }__text`}>{label}</span>
			<span className={`${ ns }__icon`} aria-hidden>{renderIcon('chevron')}</span>
		</button>
	);
};

export default ScrollHint;
